export const SINGLE_LINE_ROW_HEIGHT = 36;

export const DOUBLE_LINE_ROW_HEIGHT = 52;

// Period columns are a fixed width — a small, fixed set of reference columns
// that shouldn't grow. Carrier columns flex to fill the remaining width,
// floored at CARRIER_COL_WIDTH_PX so values stay readable and capped at
// DATA_COL_MAX_WIDTH_PX so a few carriers don't stretch comically wide.
export const PERIOD_COL_WIDTH_PX = 96; // 6rem

export const CARRIER_COL_WIDTH_PX = 152; // 9.5rem

export const DATA_COL_MAX_WIDTH_PX = 224; // 14rem
